import logEvent from '../../logEvent';

function logEventAssistedMakeContribution(code, data) {
  logEvent(`UFMC-${code}`, data);
}

export function logEventAssistedMakeContributionSelectPlan() {
  logEventAssistedMakeContribution('01');
}

export function logEventAssistedMakeContributionDetails(data) {
  logEventAssistedMakeContribution('02', data);
}

export function logEventAssistedMakeContributionReview() {
  logEventAssistedMakeContribution('03');
}

export function logEventAssistedMakeContributionSuccess() {
  logEventAssistedMakeContribution('04');
}

export function logEventAssistedMakeContributionFailure() {
  logEventAssistedMakeContribution('05');
}

export function logEventAssistedMakeContributionCannotSubmitted() {
  logEventAssistedMakeContribution('06');
}

export function logEventAssistedMakeContributionDetailsFieldsEdited(data, isReviewEdit = false) {
  const codeNumber = isReviewEdit ? '09' : '07';
  logEventAssistedMakeContribution(codeNumber, data);
}

export function logEventAssistedMakeContributionDetailsFieldsError(data) {
  logEventAssistedMakeContribution('08', data);
}
